import React from "react";
import { useContext } from "react";
import { TodoContext } from "../App";

export default function EditTodo({ id, setEditing, text }) {
  function handleChange(e) {
    e.preventDefault();
    myContext.setNewInput(e.target.value);
  }

  function handleClick() {
    myContext.editTodo(id);
    setEditing(false);
  }

  const myContext = useContext(TodoContext);

  return (
    <div className="flex justify-center items-center">
      <input
        id="todoInput"
        className="p-2 border-2 w-56 border-cyan-900 text-cyan-900 rounded-l-md focus:outline-none focus:border-cyan-300"
        type={"text"}
        placeholder="Edit your todo"
        onChange={handleChange}
        defaultValue={text}
      />
      <button
        onClick={handleClick}
        className="bg-cyan-900 text-white px-4 py-2 rounded-r-md  border-2 border-cyan-900"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>
    </div>
  );
}
